import { Injectable } from '@angular/core';
import { Observable, catchError, concatMap, map, of } from 'rxjs';
import { SelectOption } from 'src/app/shared/components/atoms/model/option.interface';
import { ProvinceIibbCategory } from '../model/province-iibb-category.interface';
import { ApiService } from 'src/app/core/service/api.service';
import { DataAfipDto, Padrones, StateName } from '../model/tax-validation';
import { InvisibleRecaptchaService } from 'src/app/core/service/invisible-recaptcha.service';

@Injectable({
  providedIn: 'root',
})
export class TaxValidationService {
  action: string = 'data_afip';
  constructor(private readonly apiSrv: ApiService, private readonly captchaSrv: InvisibleRecaptchaService) {}

  getProvinceIIBB(): Observable<ProvinceIibbCategory[]> {
    return this.apiSrv.get('api/get-provinces-and-iibb-category', { showError: true, ngxSpinner: true });
  }

  getDuplicated(numIdem: string, street: string | undefined, streetNumber: number | undefined): Observable<any> {
    const data = {
      numeroIdentificacion: numIdem,
      street: street,
      streetNumber: streetNumber,
    };
    return this.apiSrv.post('api/validate-request-is-duplicate', data, { showError: true, ngxSpinner: true });
  }

  getIIBBRate(cuitParam: string, state: string, multilateral: boolean): Observable<any> {
    let padron: number = this._getPadron(state);
    let endpoint: string = 'api/get-alicuota?cuit=' + cuitParam + '&padron=' + padron;
    if (multilateral) {
      endpoint = endpoint + '&multilateral=true';
    }
    return this.apiSrv.get(endpoint, { showError: true });
  }

  getIIBBJurisdiction(): Observable<SelectOption[]> {
    const endpoint: string = 'api/get-jurisdictions';
    return this.apiSrv.get(endpoint, { showError: true, ngxSpinner: true });
  }

  getDataAfip(cuit: string): Observable<DataAfipDto> {
    const endpoint: string = 'api/get-persona-afip';
    const cuitParam: string = encodeURIComponent(cuit);
    return this.captchaSrv.getCaptcha(this.action).pipe(
      catchError(() => of(null)),
      concatMap((token) => {
        const data = { captcha: token };
        return this.apiSrv.get(endpoint + '?cuit=' + cuitParam + '&code=' + data.captcha, { showError: false });
      }),
    );
  }

  getGenders(): SelectOption[] {
    return [
      {
        value: 'Femenino',
        text: 'Femenino',
      },
      {
        value: 'Masculino',
        text: 'Masculino',
      },
      {
        value: 'Otro',
        text: 'Otro',
      },
    ];
  }

  getDocTypes(): SelectOption[] {
    return [
      {
        value: 'Documento Único',
        text: 'Documento Único',
      },
      {
        value: 'Libreta de Enrolamiento',
        text: 'Libreta de Enrolamiento',
      },
      {
        value: 'Libreta Cívica',
        text: 'Libreta Cívica',
      },
      {
        value: 'Otros',
        text: 'Otros',
      },
    ];
  }

  private _getPadron(state: string): number {
    let padron: number;
    switch (state) {
      case StateName.BuenosAires:
        padron = Padrones.BuenosAires;
        break;
      case StateName.Cordoba:
        padron = Padrones.Cordoba;
        break;
      case StateName.EntreRios:
        padron = Padrones.EntreRios;
        break;
      default:
        padron = Padrones.SantaFe;
        break;
    }
    return padron;
  }
}
